import api from './api';

export interface SystemUpdateStatusResponse {
  success: boolean;
  data: {
    version: string;
  };
}

export interface SystemUpdateCheckData {
  upToDate: boolean;
  localVersion: string;
  remoteVersion: string;
  releaseNotes: string;
  publishedAt: string | null;
  releaseUrl: string | null;
}

export interface SystemUpdateCheckResponse {
  success: boolean;
  data: SystemUpdateCheckData;
  message?: string;
}

export type SystemUpdateJobStatus =
  | 'pending'
  | 'backing_up'
  | 'pulling'
  | 'building'
  | 'migrating'
  | 'restarting'
  | 'done'
  | 'failed';

export interface SystemUpdateProgressData {
  active: boolean;
  logId: number | null;
  status: SystemUpdateJobStatus | null;
  fromVersion: string | null;
  toVersion: string | null;
  errorMessage: string | null;
  startedAt: string | null;
  currentStepDetail?: string | null;
}

export interface SystemUpdateProgressResponse {
  success: boolean;
  data: SystemUpdateProgressData;
}

export interface SystemUpdateApplyResponse {
  success: boolean;
  message: string;
  data: {
    logId: number;
  };
}

const systemUpdateService = {
  async getStatus(): Promise<string> {
    const res: any = await api.get('/system-update/status');
    const ver = res?.data?.version ?? res?.version ?? res?.data;
    if (typeof ver === 'string' && ver.trim()) {
      return ver.trim();
    }
    if (ver && typeof ver.version === 'string' && ver.version.trim()) {
      return ver.version.trim();
    }
    throw new Error('Não foi possível obter a versão instalada do sistema.');
  },

  async checkUpdate(): Promise<SystemUpdateCheckData> {
    const response = (await api.get('/system-update/check')) as SystemUpdateCheckResponse;
    return response.data;
  },

  async applyUpdate(targetVersion: string): Promise<number> {
    const response = (await api.post('/system-update/apply', { targetVersion })) as SystemUpdateApplyResponse;
    return response.data.logId;
  },

  async getProgress(logId?: number): Promise<SystemUpdateProgressData> {
    const response = (await api.get('/system-update/progress', {
      params: logId ? { logId } : undefined,
    })) as SystemUpdateProgressResponse;
    return response.data;
  },

  async clearStuckUpdate(): Promise<void> {
    await api.post('/system-update/clear-stuck');
  },
};

export default systemUpdateService;

